import React, {useContext} from 'react';
import {SellFactorSCLContext} from "../SellFactorContext";

function FactorSellSclStatus(props) {

  const helper = useContext(SellFactorSCLContext);
  const setData = helper.setData
  const data = helper.data


  const statusHandler = (newStatus) => {

    setData({sendData: {...data.sendData, factorStatus: newStatus}})
  }


  const myClassName = (status) => {
    return `mx-1 background__gray btn btn-sm ${data.sendData.factorStatus === status ? "border border-dark" : ""}`
  }

  try {
    //inProcess, accepted, sending, delivered

    return (<div className={'divgroup '}>
      <label>وضعیت</label>
      <div className={"d-flex form-control py-3 gray"}>
        <button onClick={() => statusHandler("inProcess")} className={myClassName("inProcess")}>در حال انجام</button>
        <button onClick={() => statusHandler("accepted")} className={myClassName("accepted")}>قبول شده</button>
        <button onClick={() => statusHandler("sending")} className={myClassName("sending")}>در حال ارسال</button>
        <button onClick={() => statusHandler("delivered")} className={myClassName("delivered")}>تحویل شده</button>
      </div>

    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default FactorSellSclStatus;